import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import ContentsContext from './ContentsContext';
import ContentsReducer from './ContentsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const ContentsState = (props) => {
    const initialState = {
        getContents: {
            contents: [],
            firstContent: null,
            lastContent: null,
            nextContents: null,
            contentsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getContentsById: {
            content: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getContentsAllMonth: {
            contents: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        updateContentsById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        verifyContent: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getContentsExcel: {
            contents: [],
            contentsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        }
    }

    const { authenticatedState } = useContext(AuthenticationContext)

    const [state, dispatch] = useReducer(ContentsReducer, initialState);

    const getContents = (nextPage, prevPage) => {
        dispatch({ type: 'GET_CONTENTS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContents(nextPage, prevPage);
        } else {
            getContentsPerCountry(nextPage, prevPage, authenticatedState.user.pais);
        }
    };

    const getGlobalContents = (nextPage, prevPage) => {
        let db = firestoreInitialize();
    
        if (nextPage) {
            let first = db.collection("Contenido")
                .orderBy('postId')
                .orderBy('createdOn', 'desc')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Contenido")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Contenido")
                .orderBy('postId')
                .orderBy('createdOn', 'desc')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Contenido")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
        } else {
            let first = db.collection("Contenido")
                .orderBy('createdOn', 'desc')
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Contenido")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
        }
    };

    const getContentsPerCountry = (nextPage, prevPage, country) => {
        let db = firestoreInitialize();
    
        if (nextPage) {
            db.collection("Contenido")
                .where('postId', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Contenido")
                        .where('pais', '==', country)
                        .orderBy('createdOn', 'desc')
                        .startAfter(querySnapshot.docs[0])
                        .limit(10)

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Contenido")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    });
                })
                .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Contenido")
                .where('postId', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Contenido")
                    .where('pais', '==', country)
                    .orderBy('createdOn', 'desc')
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            let data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Contenido")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);
                                
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                    .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
                })
        } else {
            let first = db.collection("Contenido")
                .where('pais', '==', country)
                .orderBy('createdOn', 'desc')
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CONTENTS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Contenido")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CONTENTS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))   
        }
    } 

    const getContentsExcel = () => {
        dispatch({ type: 'GET_CONTENTS_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContentsExcel();
        } else {
            getContentsPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalContentsExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .orderBy('createdOn', 'desc')

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CONTENTS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_CONTENTS_EXCEL_ERROR', payload: { code: 'contents/error', message: error } }))   
    };

    const getContentsPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .where('pais', "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_CONTENTS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_CONTENTS_EXCEL_ERROR', payload: { code: 'contents/error', message: error } }))   
    }

    const getContentsNotApproved = (page) => {
        dispatch({ type: 'GET_CONTENTS_LOADING' });

        getContentsNotApprovedPerCountry(authenticatedState.user.pais, page);
    };

    const getContentsNotApprovedPerCountry = (country, page) => {
        let db = firestoreInitialize();

        db.collection('Contenido')
            .where('pais', '==', country)
            .get()
            .then((querySnapshot) => {
                let contents = querySnapshot.docs.map(doc => doc.data())
                let nextPage;

                contents = contents.filter(content => typeof content.isApproved === 'undefined');

                let nextContents;

                if (page) {
                    if (page === '1') {
                        nextContents = contents.slice(10, 11);
    
                        if (nextContents.length === 1) {
                            nextContents = true;
                        } else {
                            nextContents = false;
                        }
    
                        contents = contents.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
    
                        nextContents = contents.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);
    
                        if (nextContents.length === 1) {
                            nextContents = true;
                        } else {
                            nextContents = false;
                        }
    
                        contents = contents.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
                } else {
                    nextContents = false;
                }

                dispatch({ type: 'GET_CONTENTS', payload: { data: contents, first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1], next: nextContents} });
            })
            .catch((error) => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'contents/error', message: error } }))
    }
    
    const getContentsById = (id) => {
        dispatch({ type: 'GET_CONTENTS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Contenido").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_CONTENTS_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_CONTENTS_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_CONTENTS_BY_ID_ERROR', payload: { code: 'contents/contents-error', message: error } })
        });
    };

    const getContentsByAlly = (ally) => {
        dispatch({ type: "GET_CONTENTS_LOADING" })

        let db = firestoreInitialize();

        db.collection('Contenido')
            .where("aliadoId", "==", ally)
            .get()
            .then((querySnapshot) => dispatch({ type: 'GET_CONTENTS', payload: { data: querySnapshot.docs.map(doc => doc.data()), first: null, last: null } }))
            .catch((error) => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: "contents/error", message: error } }))
    };

    const updateContentsById = (id, data) => {
        dispatch({ type: 'UPDATE_CONTENTS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Contenido").doc(id);

        let date = firebase.firestore.FieldValue.serverTimestamp();

        docRef.update({
            isApproved: data.isApproved,
            status: data.status,
            usuarioAtendio: data.userAttends,
            fechaCierre: date,
            comentario: data.commentary
        })
        .then(() => {
            dispatch({ type: 'UPDATE_CONTENTS_BY_ID', payload: { 
                newIsApproved: data.isApproved,
                newStatus: data.status,
                newUserAttends: data.userAttends,
                newCommentary: data.commentary
            }});
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_CONTENTS_BY_ID_ERROR', payload: { code: 'content/update-error', message: error } });
        });
    };

    const updateVerifyContent = (id) => {
        dispatch({ type: 'VERIFY_CONTENT_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Contenido").doc(id);

        docRef.update({
            status: false,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_CONTENT_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_CONTENT_BY_ID_ERROR', payload: { code: 'promotion/update-error', message: error } });
        });
    };

    const updateApprovedContent = (id, isApproved) => {
        dispatch({ type: 'VERIFY_CONTENT_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Contenido").doc(id);

        docRef.update({
            isApproved: isApproved,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_CONTENT_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_CONTENT_BY_ID_ERROR', payload: { code: 'verify-content/update-error', message: error } });
        });
    };

    const resetVerifyContent = () => {
        dispatch({ type: 'VERIFY_CONTENT_BY_ID_RESET_STATE' });
    };

    const getContentsByName = (query) => {
        dispatch({ type: 'GET_CONTENTS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContentsByName(query);
        } else {
            getContentsByNameCountry(query, authenticatedState.user.pais);
        }
    };

    const getGlobalContentsByName = (query) => {
        let db = firestoreInitialize();

        db.collection('Contenido')
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].titulo && data[i].titulo.toLowerCase().includes(query.toLowerCase())) || (data[i].descripcion && data[i].descripcion.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_CONTENTS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'promotions/error', message: error } }))
    }

    const getContentsByNameCountry = (query, country) => {
        let db = firestoreInitialize();

        db.collection('Contenido')
        .where('pais', '==', country)
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].titulo && data[i].titulo.toLowerCase().includes(query.toLowerCase())) || (data[i].descripcion && data[i].descripcion.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_CONTENTS', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_CONTENTS_ERROR', payload: { code: 'promotions/error', message: error } }))
    }

    const getContentsFilter = (status, country, page) => {
        dispatch({ type: 'GET_CONTENTS_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContentsFilter(status, country, page);
        } else {
            getContentsFilterPerCountry(status, page, authenticatedState.user.pais);
        }
    }

    const getGlobalContentsFilter = (status, country, page) => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            let contents = documentSnapshots.docs.map(doc => doc.data())

            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    contents = contents.filter(content => content.isApproved === true);
                } else if (status === 'Negado') {
                    contents = contents.filter(content => content.isApproved === false);
                } else {
                    contents = contents.filter(content => typeof content.isApproved === 'undefined');
                }
            }

            if (country) {
                contents = contents.filter(content => content.pais === country)
            }

            let nextContents;

            if (page === '1') {
                nextContents = contents.slice(10, 11);

                if (nextContents.length === 1) {
                    nextContents = true;
                } else {
                    nextContents = false;
                }

                contents = contents.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextContents = contents.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextContents.length === 1) {
                    nextContents = true;
                } else {
                    nextContents = false;
                }

                contents = contents.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CONTENTS_FILTER', payload: { data: contents, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextContents } })
        })
        .catch(error => dispatch({ type: 'GET_CONTENTS_FILTER_ERROR', payload: { code: 'contents/error', message: error } }))     
    }

    const getContentsFilterPerCountry = (status, page, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .where("pais", "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }
            }

            let nextContents;

            if (page === '1') {
                nextContents = newData.slice(10, 11);

                if (nextContents.length === 1) {
                    nextContents = true;
                } else {
                    nextContents = false;
                }
                
                newData = newData.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextContents = newData.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextContents.length === 1) {
                    nextContents = true;
                } else {
                    nextContents = false;
                }

                newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CONTENTS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextContents } })
        })
        .catch(error => dispatch({ type: 'GET_CONTENTS_FILTER_ERROR', payload: { code: 'contents/error', message: error } }))     
    }

    const getContentsFilterExcel = (status, country) => {
        dispatch({ type: 'GET_CONTENTS_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContentsFilterExcel(status, country);
        } else {
            getContentsFilterPerCountryExcel(status, authenticatedState.user.pais);
        }
    }

    const getGlobalContentsFilterExcel = (status, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            let contents = documentSnapshots.docs.map(doc => doc.data())
    
            if (status) {
                if (status === 'Registrada') {
                    contents = contents.filter(content => content.isApproved === true);
                } else if (status === 'Negado') {
                    contents = contents.filter(content => content.isApproved === false);
                } else {
                    contents = contents.filter(content => typeof content.isApproved === 'undefined');
                }
            }

            if (country) {
                contents = contents.filter(content => content.pais === country)
            }

            dispatch({ type: 'GET_CONTENTS_FILTER_EXCEL', payload: { data: contents, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CONTENTS_FILTER_EXCEL_ERROR', payload: { code: 'contents/error', message: error } }))     
    };

    const getContentsFilterPerCountryExcel = (status, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Contenido")
            .where("pais", "==", country)
            .orderBy('createdOn', 'desc')

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];

            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }
            }

            dispatch({ type: 'GET_CONTENTS_FILTER_EXCEL', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CONTENTS_FILTER_EXCEL_ERROR', payload: { code: 'contents/error', message: error } }))     
    }

    const getContentsAllMonth = async (country) => {
        dispatch({ type: 'GET_CONTENTS_ALL_MONTH_LOADING' });

        if (country) {
            getContentsAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalContentsAllMonth();
        } else {
            getContentsAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalContentsAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let contentsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Contenido')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                contentsPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_CONTENTS_ALL_MONTH', payload: { data: contentsPerMonth } });
    }

    const getContentsAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let contentsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Contenido')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                contentsPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_CONTENTS_ALL_MONTH', payload: { data: contentsPerMonth } });
    }

    const resetContentsState = () => {
        dispatch({ type: 'CONTENTS_RESET_STATE' });
    };

    const resetContentsExcelState = () => {
        dispatch({ type: 'CONTENTS_EXCEL_RESET_STATE' });
    };

    return (
        <ContentsContext.Provider value={{
            contentsState: state.getContents,
            contentsByIdState: state.getContentsById,
            contentsAllMonthState: state.getContentsAllMonth,
            contentsUpdateState: state.updateContentsById,
            verifyContentState: state.verifyContent,
            contentsExcelState: state.getContentsExcel,
            getContents,
            getContentsExcel,
            getContentsFilterExcel,
            getContentsNotApproved,
            getContentsById,
            getContentsByAlly,
            updateContentsById,
            updateVerifyContent,
            updateApprovedContent,
            getContentsByName,
            getContentsFilter,
            getContentsAllMonth,
            resetContentsState,
            resetContentsExcelState,
            resetVerifyContent,
        }}>
            {props.children}
        </ContentsContext.Provider>
    )
}

export default ContentsState;
